import { Docket, PrinterProfile } from '@oolio-group/domain';
import { consolidateOrderItems } from '../printerUtils';

export function consolidateDockets(
  filteredDockets: Docket[],
  printerProfiles: PrinterProfile[],
): Docket[] {
  if (!filteredDockets) return [];
  const printerProfilesMap = new Map<string, boolean>();
  printerProfiles.forEach(profile => {
    printerProfilesMap.set(profile.id, profile.combineIdenticalItems ?? false);
  });

  const consolidatedDockets = filteredDockets.map(docket => {
    const shouldCombine = printerProfilesMap.get(docket.printerProfileId);

    if (shouldCombine !== true) return docket;

    const newDocket = { ...docket };
    newDocket.docketItems = consolidateOrderItems(docket.docketItems);
    return newDocket;
  });

  return consolidatedDockets;
}
